import _ from "lodash";
import {isNumeric} from "../RouteTimeCircle/RouteTimeCircle";
import {sessionSet} from "../../Utils/SessionStorageUtils";

export default class SettingsConfig {
    constructor(settings, options) {
        this.setOptions(options);
        this.setSettings(settings);
    }

    getSettingsConfig() {
        return this.settingsConfig;
    }

    anyErrors() {
        const {settingsConfig, advancedSettingsConfig} = this.settingsConfig;

        const listOfSettingsConfig = settingsConfig.concat(advancedSettingsConfig);

        return listOfSettingsConfig
            .filter(settingConfig => settingConfig.condition)
            .some(settingConfig => settingConfig.error);
    }

    setOptions(options) {
        this.options = options;
    }

    setSettings(settings) {
        this.settingsConfig = {
            settingsConfig: [
                {
                    name: "id",
                    displayName: "מזהה מסעדה",
                    type: "text",
                    condition: this.options.withIdInput
                },
                {
                    name: "name",
                    displayName: "שם בית העסק",
                    type: "text"
                },
                {
                    name: "address",
                    displayName: "כתובת",
                    placeholder: "הקלד כתובת",
                    type: "address"
                },
                {
                    name: "phoneNumber",
                    displayName: "מספר טלפון",
                    type: "text"
                },
                {
                    name: "timeInPlace",
                    displayName: "שהייה בהגעה לכתובת בדק'",
                    type: "number"
                },
                {
                    name: "timeInPlaceSame",
                    displayName: "שהייה בכתובת זהה לקודמת בדק'",
                    type: "number"
                },
                {
                    name: "maxGroupSize",
                    displayName: "כמות הזמנות מקסימלית בשילוח",
                    type: "number"
                },
                {
                    name: "sla",
                    displayName: "זמן התחייבות ברירת מחדל בדק'",
                    type: "number"
                },
                {
                    name: "isAreaSlaEnabled",
                    displayName: "זמן התחייבות לפי אזורים",
                    type: "toggle"
                },
                {
                    name: "orderStatusWhenAdded",
                    displayName: "סטטוס התחלתי להזמנה",
                    type: "menu",
                    options: [
                        {value: "ACCEPTED", displayName: "התקבל"},
                        (settings.isAutopilot ?
                            {value: "SCHEDULED_READY", displayName: "מתוזמן להיות מוכן"} :
                            {value: "READY", displayName: "מוכן"})
                    ]
                },
                {
                    name: "scheduleReadyMinutesWhenAdded",
                    displayName: "מספר דקות לתזמון התחלתי להזמנה",
                    type: "number",
                    condition: settings.orderStatusWhenAdded === "SCHEDULED_READY",
                    error: (settings.scheduleReadyMinutesWhenAdded === undefined || settings.scheduleReadyMinutesWhenAdded === null ||
                        settings.scheduleReadyMinutesWhenAdded === "" || settings.scheduleReadyMinutesWhenAdded < 0)
                },
                {
                    name: "isMessengersOrdersOweEnabled",
                    displayName: "מערכת זיכויי הזמנות לשליחים",
                    type: "toggle"
                },
                {
                    name: "isMessengersManualOweEnabled",
                    displayName: "מערכת חובות ידניים שליחים",
                    type: "toggle"
                },
                {
                    name: "readySla",
                    displayName: "זמן התרעת הזמנה מוכנה בדק'",
                    type: "number"
                },
                {
                    name: "deliveryDurationSla",
                    displayName: "זמן מקסימלי להזמנה בנסיעה",
                    type: "number"
                },
                {
                    name: "isOrderAfterCloseSetToOpenEnabled",
                    displayName: "האם כשנכנסת הזמנה לאחר הסגירה לתזמן אותה לפתיחה",
                    type: "toggle"
                },
                {
                    name: "openTimes[0].open",
                    condition: settings.isOrderAfterCloseSetToOpenEnabled,
                    displayName: "זמן פתיחה",
                    error: !_.get(settings, "openTimes[0].open"),
                    type: "time"
                },
                {
                    name: "openTimes[0].close",
                    condition: settings.isOrderAfterCloseSetToOpenEnabled,
                    displayName: "זמן סגירה",
                    error: !_.get(settings, "openTimes[0].close"),
                    type: "time"
                },
                {
                    name: "notifications.newOrder",
                    displayName: "התראה על הזמנה חדשה",
                    type: "toggle"
                },
                {
                    name: "notifications.updateOrder",
                    displayName: "התראה על הזמנה שעודכנה",
                    type: "toggle"
                },
                {
                    name: "notifications.deleteOrder",
                    displayName: "התראה על הזמנה שנמחקה",
                    type: "toggle"
                },
                {
                    name: "notifications.newUser",
                    displayName: "התראה על משתמש חדש",
                    type: "toggle"
                },
                {
                    name: "notifications.updateUser",
                    displayName: "התראה על משתמש שעודכן",
                    type: "toggle"
                },
                {
                    name: "notifications.deleteUser",
                    displayName: "התראה על משתמש שנמחק",
                    type: "toggle"
                },
                {
                    name: "notifications.newAssignedGroup",
                    displayName: "התראה על שיבוץ משימת שילוח",
                    type: "toggle"
                },
                {
                    name: "notifications.updateAssignedGroup",
                    displayName: "התראה על עדכון משימת שילוח",
                    type: "toggle"
                },
                {
                    name: "notifications.deleteAssignedGroup",
                    displayName: "התראה על ביטול משימת שילוח",
                    type: "toggle"
                },
                {
                    name: "deleteAcceptedOrdersMinutes",
                    displayName: "מחיקת הזמנות בסטטוס התקבל לאחר זמן בדק׳",
                    type: "number",
                    error: settings.deleteAcceptedOrdersMinutes !== null && settings.deleteAcceptedOrdersMinutes <= 0
                },
                {
                    name: "isAutopilot",
                    displayName: "משלח אוטונומי",
                    type: "toggle"
                },
                {
                    name: "yangoAuthToken",
                    displayName: "זיהוי יאנגו",
                    type: "text",
                    condition: settings.isAutopilot
                },
                {
                    name: "clearIgnoredOrderGroups",
                    displayName: "נקה ביטול קבוצות מרוכזות",
                    type: "button",
                    condition: settings.isMerukazotEnabled,
                    onClick: () => sessionSet("ignoredOrderIdsForGrouping", [], 1440)
                },
            ],
            advancedSettingsConfig: [
                {
                    name: "scheduledSlaAfter",
                    displayName: "זמן התחייבות הגעה לאחר השעה הנקבעת בהזמנה עתידית בדק'",
                    type: "number"
                },
                {
                    name: "scheduledSlaBefore",
                    displayName: "זמן התחייבות הגעה לפני השעה הנקבעת בהזמנה עתידית בדק'",
                    type: "number"
                },
                {
                    name: "urgentSla",
                    displayName: "זמן התחייבות להזמנה דחופה בדק'",
                    type: "number"
                },
                {
                    name: "minAddressChangeRecommendationDialog",
                    displayName: "כמות שינויי כתובת כדי שהשינוי יופיע בדיאלוג המלצות",
                    type: "number",
                    error: settings.minAddressChangeRecommendationDialog <= 0
                },
                {
                    name: "minAddressChangeRecommendationFly",
                    displayName: "כמות שינויי כתובת כדי שהשינוי יקפוץ בשינוי כתובת",
                    type: "number",
                    error: settings.minAddressChangeRecommendationFly <= 0
                },
                {
                    name: "kibanaUrl",
                    displayName: "קישור לקיבאנה",
                    type: "text"
                },
                {
                    name: "isNotifyCustomerOnOrderAccepted",
                    displayName: "טראקר לקוח",
                    type: "toggle"
                },
                {
                    name: "smsSenderName",
                    condition: settings.isNotifyCustomerOnOrderAccepted,
                    displayName: "שם השולח בהודעה של הטראקר",
                    error: settings.smsSenderName && (settings.smsSenderName.length > 11 || isNumeric(settings.smsSenderName)),
                    type: "text"
                },
                {
                    name: "orderTrackerMaxMinutesShowTimes",
                    condition: settings.isNotifyCustomerOnOrderAccepted,
                    displayName: "זמן מקסימלי בדקות לתצוגת זמנים בטראקר",
                    type: "number"
                },
                {
                    name: "isSendGroupSmsCourierEnabled",
                    displayName: "שליחת SMS לשליחים בציוות מסלול",
                    type: "toggle"
                },
                {
                    name: "isOrdersIntegrationInputEnabled",
                    displayName: "כניסת הזמנות ממערכות צד שלישי",
                    type: "toggle"
                },
                {
                    name: "isAssignmentsIntegrationOutputEnabled",
                    displayName: "שיתוף מידע של שיבוץ שליחים למערכות צד שלישי",
                    type: "toggle"
                },
                {
                    name: "isDeliveredIntegrationOutputEnabled",
                    displayName: "שיתוף מידע של מסירת הזמנות למערכות צד שלישי",
                    type: "toggle"
                },
                {
                    name: "isMergeOrderCommentIntoDeliveryCommentEnabled",
                    displayName: "האם להכניס הערות הזמנה לתוך הערות שליח",
                    type: "toggle"
                },
                {
                    name: "isScheduleNotificationsEnabled",
                    displayName: "התראות תזמון לטלגרם",
                    type: "toggle"
                },
                {
                    name: "telegramNotificationsChannel",
                    displayName: "ערוץ טלגרם להתראות",
                    type: "text"
                },
                {
                    name: "isDemo",
                    displayName: "דמו",
                    type: "toggle"
                },
                {
                    name: "dailyLimit",
                    displayName: "הגבלה יומית בדמו",
                    type: "number",
                    condition: settings.isDemo
                },
                {
                    name: "isMerukazotEnabled",
                    displayName: "מרוכזות",
                    type: "toggle"
                },
                {
                    name: "merukazotMin",
                    displayName: "מינימום הפעלת מרוכזות",
                    type: "number",
                    condition: settings.isMerukazotEnabled
                },
                {
                    name: "featureCoefficients.durationStandardDeviation",
                    displayName: "משקל סטיית תקן זמן נסיעה מינימלי",
                    type: "number"
                },
                {
                    name: "polygonToShow",
                    displayName: "פוליגון על המפה",
                    type: "text"
                },
                {
                    name: "ignoreOrdersOutsidePolygon",
                    displayName: "פוליגון לחסימת הזמנות",
                    type: "text"
                }
            ]
        }
    }
}